import logo from "assets/images/brands/Seamless-Logo.png";

export const clientName = "Seamless Markets";
export const developedBy = "Seamless Markets";
export const imagesUrl = process.env.REACT_APP_API_IMAGES_URL;
export const cpUrl = process.env.REACT_APP_CP_URL;
export const apiUrl = process.env.REACT_APP_API_CP_DOMAIN;
export const companyName =  "Seamless Markets";
export const companyWebsite = "#";
export const privacyPolicyLink = `${cpUrl}/Privacy_Policy_SML.pdf`;
export const clientAgreementLink = `${cpUrl}/Client_Agreement_Seamless_Markets_Limited.pdf`;
export const AMLPolicyLink = `${cpUrl}/AML_Policy_(SML)_2024.pdf`;
export const riskWarningLink = `${cpUrl}/RISK_WARNING_SML.pdf`;
export const sidebarLogo = logo;
export const smLogo = logo;
export const mainLogo = logo;
export const footerLogo = logo;
